export const DATE = "YYYY-MM-DD";

// A finite number from a number or numeric string, otherwise null.
export const finiteOrNull = (v) => {
    if (v === null || v === undefined || v === "") return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};

export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
